import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage, injectIntl } from 'react-intl'
import cx from 'classnames'
import _ from 'lodash'

import { LOCALE_PREFIX } from '../../constants'

import hocConnect from './hocConnect'

import './style.scss'

@injectIntl
@hocConnect
export default class FilterButton extends Component {
    static propTypes = {
        buttonKey: PropTypes.string.isRequired,
        disabled: PropTypes.bool,
        groupId: PropTypes.number.isRequired,
        groupStackState: PropTypes.object,
    }

    constructor(props) {
        super(props)

        this.state = {
            active: false,
            inputValue: '',
        }
        this.debouncedFilter = _.debounce(() => {
            this.props.filterGroupMembers(
                this.state.inputValue,
                this.props.groupId,
                this.props.groupStackState?.groupData?.page
            )
        }, 300)
    }

    componentDidUpdate(nextProps) {
        const { groupId: currentGroupId } = this.props
        const { groupId: nextGroupId } = nextProps

        if (currentGroupId !== nextGroupId) {
            this.clearState()
        }
    }

    clearState() {
        this.setState({
            active: false,
            inputValue: '',
        })
    }

    handleBtnClick = () => {
        const { active } = this.state

        this.setState({
            active: !active,
        })
    }

    handleInputChange = (e) => {
        e.preventDefault()
        const inputValue = e.target.value

        this.setState({
            inputValue,
        })

        this.debouncedFilter()
    }

    handleClearBtnClick = () => {
        this.setState({ inputValue: '' })

        this.debouncedFilter()
    }

    handleCloseBtnClick = () => {
        this.setState({ active: false })
    }

    render() {
        const { buttonKey, disabled, intl } = this.props
        const { active, inputValue } = this.state

        return (
            <div className={'group-stack-filter-wrapper'}>
                <button
                    key={`group-stack-header-${buttonKey}-button`}
                    className={cx(`group-stack-header-filter-button`, {
                        'is-disabled': disabled,
                        'is-active': active,
                    })}
                    disabled={disabled}
                    onClick={this.handleBtnClick}
                >
                    <FormattedMessage id={`${LOCALE_PREFIX}.filterGroupMembers`} />
                </button>
                {active && (
                    <>
                        <div className={'filter-menu'}>
                            <input
                                type={'text'}
                                name={'group-stack-header-filter-input'}
                                placeholder={intl.formatMessage({ id: `${LOCALE_PREFIX}.filterInputPlaceholder` })}
                                value={inputValue}
                                onChange={(e) => this.handleInputChange(e)}
                            />
                            <div className={'filter-btns-row'}>
                                <button
                                    key={'group-stack-header-filter-menu-clear-input'}
                                    className={'filter-menu-btn clear-input'}
                                    title={intl.formatMessage({ id: `${LOCALE_PREFIX}.clearFilter` })}
                                    onClick={this.handleClearBtnClick}
                                />
                                <button
                                    key={'group-stack-header-filter-menu-clost'}
                                    className={'filter-menu-btn close'}
                                    title={intl.formatMessage({ id: `${LOCALE_PREFIX}.closeFilterMenu` })}
                                    onClick={this.handleCloseBtnClick}
                                />
                            </div>
                        </div>
                        <div className={'filter-menu-top-border'} />
                    </>
                )}
            </div>
        )
    }
}
